module.exports = __webpack_public_path__ + "img/favicon_havet.98afd58e.svg";